const ImageCover = (({ jQuery: $ }) => {
    class ImageCover {
        constructor($node) {
            this.$node = $($node);
        }

        getArea(element) {
            let area = element.clientWidth * element.clientHeight;
            return area;
        }

        shouldCover() {
            this.$node.map((index, element) => {
                let image = element.querySelector('img');
                let imageArea = this.getArea(image);
                let elementArea = this.getArea(element);

                if (elementArea > imageArea) {
                    let scale = elementArea / imageArea;
                    let scaleFactor = scale.toFixed(2) * 1.1;

                    this.applyImageCover(scaleFactor, image);
                }
            });
        }

        applyImageCover(scaleFactor, image) {
            image.style.msTransform = 'scale(' + scaleFactor + ')';
            image.style.webkitTransform = 'scale(' + scaleFactor + ')';
            image.style.MozTransform = 'scale(' + scaleFactor + ')';
            image.style.OTransform = 'scale(' + scaleFactor + ')';
            image.style.transform = 'scale(' + scaleFactor + ')';
        }

        onWindowResize() {
            this.shouldCover();
        }

        setEventBindings() {
            window.addEventListener('resize', this.onWindowResize.bind(this));
        }

        init() {
            this.shouldCover();
            this.setEventBindings();
        }
    }

    return {
        init({ selector }) {
            return new ImageCover(selector).init();
        },
    };
})(window);

export default Object.create(ImageCover);
